import React from "react";
import MetaAdLandings from "../meta-ad-landings";
import Footer from "../global/footer";

const MetaAdLanding = ({ footer }) => {
  const { menuv3 } = footer;
  return (
    <>
      <MetaAdLandings isBg="yes" />
      <Footer isBg="yes" menu={menuv3} />
    </>
  );
};

export default MetaAdLanding;